import { render, staticRenderFns } from "./downTask.vue?vue&type=template&id=7b35e730&scoped=true"
import script from "./downTask.vue?vue&type=script&lang=js"
export * from "./downTask.vue?vue&type=script&lang=js"
import style0 from "./downTask.vue?vue&type=style&index=0&id=7b35e730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b35e730",
  null
  
)

export default component.exports